/* eslint-disable */

import request from '@/utils/request'

export function getUserApi(query) {
  return request({
    url: '/config-service/v1/account',
    method: 'get',
    params: query
  })
}

export function addUserApi(query) {
  return request({
    url: '/config-service/v1/account',
    method: 'post',
    data: query
  })
}

export function updateUserApi(query) {
  return request({
    url: `/config-service/v1/account/${query.id}`,
    method: 'put',
    data: query
  })
}
export function deleteUserApi(query) {
  return request({
    url: '/config-service/v1/account',
    method: 'delete',
    data: query
  })
}
export function getFunctionAssignApi(params) {
  return request({
    url: '/config-service/v1/account/assign',
    method: 'get',
    params: params
  })
}
export function setFunctionAssignApi(userId, functionIds) {
  return request({
    url: `/config-service/v1/account/assign/${userId}`,
    method: 'put',
    data: functionIds
  })
}
export function resetPasswordApi(payload) {
  return request({
    url: '/config-service/v1/account/update-password',
    method: 'put',
    data: payload
  })
}
